// extracted by mini-css-extract-plugin
export default {"mainContainer":"MainLayout_mainContainer__Pnrm-","bodyContainer":"MainLayout_bodyContainer__k9Vf+","noNavbar":"MainLayout_noNavbar__APskn"};